//
// Update the query params for filtering entries
//
import URI from 'urijs';
import { component as defineComponent } from 'flightjs';

var filterCriteriaUpdater = function () {
    this.attributes({
        listenEvent: '',
        eventToTrigger: '',
    });

    this.after('initialize', function () {
        this.on(this.attr.listenEvent, this.handleFilterChange);
    });

    this.handleFilterChange = function (e, data) {
        var filters;

        if (!data.filters && !data.name && !data.value) {
            filters = null;
        } else {
            if (data.filters === undefined) {
                filters = [
                    {
                        name: data.name,
                        value: data.value,
                    },
                ];
            } else {
                filters = data.filters;
            }
        }

        this.updateFilters(filters);
    };

    this.updateFilters = function (filters) {
        var uri = this.prepareUri(filters);
        var payload;

        if (filters === null) {
            payload = {
                url: uri.path(),
            };
        } else {
            payload = {
                url: uri.path() + uri.search() + uri.hash(),
            };
        }

        this.trigger(this.attr.eventToTrigger, payload);
    };

    this.prepareUri = function (filters) {
        var uri = new URI(this.getCurrentLocation());
        uri.removeSearch('page');

        if (filters !== null) {
            filters.forEach(function (filter) {
                uri = this.applyFilter.call(uri, filter);
            }, this);
        }

        return uri;
    };

    this.getCurrentLocation = function () {
        return window.location.href;
    };

    this.applyFilter = function (filter) {
        var uri = this;
        var name = filter.name;
        var value = filter.value;

        switch (name) {
            case 'designer':
                uri = uri.setSearch(name, value);
                break;
            case 'groupby':
                if (typeof value === 'boolean') {
                    value = value ? 'designer' : 'none';
                } else {
                    if (value === 'on' || value === 'designer') {
                        value = 'designer';
                    } else {
                        value = 'none';
                    }
                }

                uri = uri.setSearch(name, value);

                break;
            case 'own':
                if (value) {
                    uri = uri.setSearch(name, 'true');
                } else {
                    uri = uri.removeSearch(name);
                }

                break;
            case 'filter':
            case 'sort':
                uri = uri.removeSearch('page').setSearch(name, value);
                break;
        }

        return uri;
    };
};

export default defineComponent(filterCriteriaUpdater);



// WEBPACK FOOTER //
// ./src/web/js/contest/data/filter-criteria-updater.js